import React from "react";
import "./Music.scss";
import MusicHeader from "../components/music/MusicHeader.jsx";
import MusicInfo from "../components/music/MusicInfo.jsx";
import MusicTracks from "../components/music/MusicTracks.jsx";
import MusicAlbums from "../components/music/MusicAlbums.jsx";
import MusicVideos from "../components/music/MusicVideos.jsx";

function Music() {
  return (
    <>
      <div id="music">
        <MusicHeader />
        <div id="music-body" className="fade-in three">
          <div id="track-info-container">
            <MusicInfo />
            <MusicTracks />
          </div>
          <MusicAlbums />
          <MusicVideos />
        </div>
      </div>
    </>
  );
}

export default Music;
